import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Set noindex meta tag for 404 pages
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    metaRobots.setAttribute('content', 'noindex, nofollow');
    
    document.title = '404 - Page Not Found | NoQ5.ai';
    
    // Set meta description for 404
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Page not found. Visit NoQ5.ai for AI revenue intelligence, CRM automation, and deal forecasting.');
    }
    
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    
    return () => {
      // Restore indexable robots tag
      if (metaRobots) {
        metaRobots.setAttribute('content', 'index, follow');
      }
    };
  }, [location.pathname]);

  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center max-w-lg px-4">
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-foreground mb-4">{t('notFound.title')}</h2>
        <p className="text-lg text-muted-foreground mb-8">{t('notFound.message')}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className="px-6 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors">
            {t('notFound.home')}
          </Link>
          <Link to="/blog" className="px-6 py-3 border border-border rounded-lg font-medium text-foreground hover:bg-muted transition-colors">
            Read Blog
          </Link>
          <Link to="/use-cases" className="px-6 py-3 border border-border rounded-lg font-medium text-foreground hover:bg-muted transition-colors">
            Use Cases
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
